import api from './api';

// ============================================
// FooterService – Port des Flutter FooterService
// Lädt die dynamisch gepflegten Footer-Sektionen vom Backend.
// GET /api/footer/sections -> { data: [ { _id, title, order, isVisible, items:[...] } ] }
// ============================================

export interface FooterItem {
  id: string;
  label: string;
  route: string;
  order: number;
  isVisible: boolean;
}

export interface FooterSection {
  id: string;
  title: string;
  order: number;
  isVisible: boolean;
  items: FooterItem[];
}

const parseItem = (raw: any): FooterItem => ({
  id: raw?._id ?? raw?.id ?? '',
  label: raw?.label ?? '',
  route: raw?.route ?? '',
  order: raw?.order ?? 0,
  isVisible: raw?.isVisible ?? true,
});

const parseSection = (raw: any): FooterSection => ({
  id: raw?._id ?? raw?.id ?? '',
  title: raw?.title ?? '',
  order: raw?.order ?? 0,
  isVisible: raw?.isVisible ?? true,
  items: Array.isArray(raw?.items) ? raw.items.map(parseItem) : [],
});

class FooterService {
  /** Sichtbare Footer-Sektionen. Gibt null zurück, wenn das Backend nicht erreichbar ist. */
  async getVisibleSections(): Promise<FooterSection[] | null> {
    try {
      const res = await api.get('/api/footer/sections');
      const data = res?.data?.data;
      if (!Array.isArray(data)) return null;
      return data.map(parseSection);
    } catch {
      return null;
    }
  }
}

export default new FooterService();
